import Vue from 'vue'
import Snotify, { SnotifyPosition } from 'vue-snotify'

const options = {
    toast: {
        timeout: 2000,
        showProgressBar: true,
        pauseOnHover: false,
        position: SnotifyPosition.rightBottom
    }
}
Vue.use(Snotify, options)


// WEBPACK FOOTER //
// ./src/plugins/notifications.js